import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, UncontrolledTooltip } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import Select from 'react-select/async';
import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
import _ from 'lodash';
import Services from './services';
import Mezo from './Mezo';
import {DatePicker, PaginationTotal } from '../../../commons/controls';
import { ProgressButton } from '../../../commons/ProgressButton';
import QueryEmptyState from '../../../commons/queryempty';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import SwichButton from '../../../commons/SwitchButton';
import Loader from '../../../commons/loader';
import NumberFormatter from '../../../commons/NumberFormatter';
import SlaveAvInput from '../../../commons/SlaveAvInput';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import { Field } from 'react-final-form';
import Lib from '../../../commons/lib';

class CikktorzsContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // ['LOAD', 'DATA', 'NETW', 'TABL', 'QUERY']
      tableStatus: 'QUERY',
      // ['LOAD', 'DATA', 'NETW']
      formStatus: 'DATA',

      // FORM VALUES
      formTipus: '',
      formReceptura: false,
      formCikkcsoport: '',
      formCikkszam: '',
      formMegnevezes: '',
      formMennyiseg: '',
      formAfa: '',
      formAfaTable: [],
      formAfaKezdete: '',
      formWebshop: false,
      formRaktaronKivuli: false,
      formStatusz: '',
      formChilds: [],
      formMetadata: [],

      // MODALS
      modalForm: false,
      modalView: false,
      modalDelete: false,
      modalMetadata: false,
      modalMennyiseg: false,
      modalChildDelete: false,

      // UTILS
      modositas: false,
      hidden: false,
      expanded: [],
      currentId: null,
      baseJson: [],
      saveButtonLoading: false,
      cikkDeleteLoading: false,

      recepturaJson: new Map(),
      cikk: null,
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
    };
  }

  // componentDidMount() {
  //   this.getData();
  // }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.getData();
      }
    }
  }

  getData = () => {
    this.setState({
      tableStatus: 'LOAD'
    }, () => {
      Promise.all([
        this.listCikk(),
        this.getCikkProfil(),
      ])
      .then((prevState) => {
        this.setState({ 
          tableStatus: this.state.baseJson && this.state.baseJson.length > 0 ? 'TABL' : 'DATA',
        });
      })
      .catch(() => {
        this.setState({
          tableStatus: 'NETW'
        });
      });
    });
  }

  hasRoleSpec = (roles) => {
    return this.props.globals.hasRoleSpec(roles);
  }

  nullToString = (data) => {
    if (!data) return '';
    return data;
  }

  emptyOrNull = (data) => {
    if (!data || data === '') return null;
    return data;
  }

  getCikk = (id) => {
    return new Promise((resolve, reject) => {
      Services.getCikk(id, (err, res) => {
        if (!err) {
          let metaadatok = [];
          if (res[0].metaadatok) {
            let i = 0;
            for (const [nev, ertek] of Object.entries(res[0].metaadatok)) {
              metaadatok.push({ key: ++i, nev, ertek })
            };
          }
          this.setState({
            formCikkcsoport: this.nullToString(res[0].cikkcsoport.id), 
            formMennyiseg: this.nullToString(res[0].mennyiseg.id),
            formAfa: this.nullToString(res[0].aktualisAfaId), 
            formReceptura: res[0].haschild,
            formTipus: this.nullToString(res[0].tipus),
            formCikkszam: this.nullToString(res[0].cikkszam),
            formMegnevezes: this.nullToString(res[0].megnevezes),
            formAfaKezdete: res[0].aktualisAfaKezdete,
            formWebshop: res[0].webshop,
            formRaktaronKivuli: res[0].raktaronKivuli,
            formStatusz: res[0].statusz,
            formChilds: res[0].childs ? res[0].childs : [],
            formMetadata: metaadatok,
            formAfaTable: res[0].afak ? res[0].afak : [],
          }, () => {
            resolve();
          });
        }else{
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  handleSubmit = (e, values) => {
    let {
      formTipus,
      formReceptura,
      formCikkcsoport,
      formCikkszam,
      formMegnevezes,
      formMennyiseg,
      formAfa,
      formAfaKezdete,
      formChilds = [],
      formMetadata,
      modositas,
      currentId
    } = this.state;
    let {
      formStatusz,
      formWebshop,
      formRaktaronKivuli
    } = values;
    let metaadatok = {};
    formMetadata.forEach(metaadat => {
      metaadatok[metaadat.nev] = metaadat.ertek;
    });

    this.setState({ saveButtonLoading: true }, () => {
    let submitObj = {};
    submitObj.tipus = this.emptyOrNull(formTipus);
    submitObj.receptura = this.emptyOrNull(formReceptura);
    submitObj.cikkcsoportid = this.emptyOrNull(formCikkcsoport);
    submitObj.cikkszam = this.emptyOrNull(formCikkszam);
    submitObj.megnevezes = this.emptyOrNull(formMegnevezes);
    submitObj.mennyisegid = this.emptyOrNull(formMennyiseg);
    submitObj.afaid = this.emptyOrNull(formAfa);
    submitObj.kezdete = this.emptyOrNull(formAfaKezdete);
    submitObj.webshop = formWebshop;
    submitObj.raktaronkivuli = formRaktaronKivuli;
    submitObj.statusz = formStatusz;
    submitObj.metaadatok = this.emptyOrNull(metaadatok);

    let recepturaArray = [];
    formChilds.forEach((child) => {
      let receptura = {};
      receptura.cikkid = child.childid;
      receptura.mennyiseg = NumberFormatter.removeSpacesFromString(child.childmennyiseg);
      recepturaArray.push(receptura);
    });
    submitObj.recepturacikkek = recepturaArray;

    if (modositas) {
      submitObj.id = currentId;
      Services.editCikk(submitObj, (err) => {
        if (!err) {
            this.toggleForm();
            this.getData();
            this.props.globals.addSuccess('Cikk módosítva!');
        }
        this.setState({ saveButtonLoading: false });
      });
    }else{ 
      Services.addCikk(submitObj, (err) => {
        if (!err) {
          this.toggleForm();
          this.getData();
          this.props.globals.addSuccess('Cikk felvéve!');
        }
        this.setState({ saveButtonLoading: false });
      });
    }
    });
  }

  listCikk = () => {
    return new Promise((resolve, reject) => {
      Services.listCikk((err, res) => {
        if (!err) {
          let filters = {};
          let options = res[0].statusz.map((e) => {
            filters[e.name] = e.caption;

            return <option key={e.name} value={e.name}>{e.caption}</option>;
          });

          this.setState({
            baseJson: res[0].list,
            expanded: [],
            filterOptions: filters,
            statusz: res[0].statusz,
            statuszOptions: options
          }, () => {
            resolve();
          });
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  getCikkProfil = () => {
    return new Promise((resolve, reject) => {
      Services.getCikkProfil( (err, res) => {
        if (!err) {
          this.setState({
            hidden: res[0] == 'false',
          }, () => {
            resolve();
          });
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  renderCikkcsoportOptions = () => {
    return new Promise((resolve, reject) => {
      Services.listLeavesCikkcsoport((err, res) => {
        if (!err) {
          this.setState({ 
            cikkcsoportOptions: res[0].map(e => <option key={e.id} value={e.id}>{e.nev}</option>) 
          }, () => {
            resolve();
          });
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  renderMennyisegOptions = () => {
    return new Promise((resolve, reject) => {
      Services.listMennyiseg((err, res) => {
        if (!err) {
          this.setState({ 
            mennyisegOptions: res[0].map(e => <option key={e.id} value={e.id}>{e.nev}</option>) 
          }, () => {
            resolve();
          });
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  renderAfaOptions = () => {
    return new Promise((resolve, reject) => {
      Services.listAfa((err, res) => {
        if (!err) {
          this.setState({
            afaOptions: res[0].list.map((e) => {
              let s = this.state.statusz.find(x => x.name === e.statusz);
              return <option key={e.id} value={e.id} disabled={e.statusz === 'INAKTIV'}>{e.megnevezes + ' - (' + e.ertek + '%) - ' + s.caption}</option>;
            }),
          }, () => {
            resolve();
          });
        } else {
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  loadOptionsCikkChildsMegnevezes = (text, callback) => {
    this.loadOptionsCikkChilds(text, callback, {megnevezes : text});
  }

  loadOptionsCikkChildsCikkszam = (text, callback) => {
    this.loadOptionsCikkChilds(text, callback, {cikkszam : text, id: this.state.currentId});
  }

  loadOptionsCikkChilds = (text, callback, param) => {
    const newParam = Object.keys(param).reduce((object, key) => {
      if(param[key]){
        object[key] = param[key];
      }
      return object;
    }, {});
    
    let newArray = [];
    if (text.length === 0) {
      callback(newArray);
    } else {
      Services.listCikkToChilds(newParam, (err, res) => {
        if (!err) {
          res[0].forEach((res1) => {
            res1.childid = res1.id;
            res1.childcikkszam = res1.cikkszam;
            res1.childmegnevezes = res1.cikknev;
            res1.childaktualisafanev = res1.afanev;
            res1.childaktualisafaertek = res1.afa;
            res1.childmennyiseg = null;
            newArray.push(res1);
          })
          callback(newArray);
        }
      });
    }
  }

  newCikkForm = () => {
    this.setState({
      formTipus: '',
      formReceptura: false,
      formCikkcsoport: '',
      formCikkszam: '',
      formMegnevezes: '',
      formMennyiseg: '',
      formAfa: '',
      formAfaKezdete: '',
      formWebshop: false,
      formRaktaronKivuli: false,
      formStatusz: 'AKTIV',
      formChilds: [],
      formMetadata: [],
      modositas: false,
      currentId: null,
    }, () => {
      this.toggleForm();
    });
  }

  toggleForm = () => {
    this.setState({ formStatus: 'LOAD'}, () => {
      if (!this.state.modalForm) {
        Promise.all([
          this.renderAfaOptions(),
          this.renderCikkcsoportOptions(),
          this.renderMennyisegOptions()
        ])
        .then((prevState) => {
          this.setState({
            modalForm: !prevState.modalForm,
            formStatus: 'DATA'
          });
        })
        .catch(() => {
          this.setState({
            formStatus: 'NETW'
          });
        });
      } else {
        this.setState({
          modalForm: !this.state.modalForm,
          currentId: null,
          modositas: false
        }, () => {
          // this.getData();
        });
      }
    });
  }
 
  toggleChildDelete = (idx) => {
    this._currentDeleteChildId = idx;
    this.setState({
      modalChildTorles: !this.state.modalChildTorles
    });
  }

  toggleAfaDelete = () => {
    this.setState({
      modalAfaDelete: !this.state.modalAfaDelete
    });
  }

  toggleView = () => {
    this.setState({
      modalView: !this.state.modalView
    });
  }

  toggleDelete = () => {
    this.setState({
      modalDelete: !this.state.modalDelete
    });
  }

  toggleChildDelete = (idx) => {
    this._currentDeleteChildId = idx;
    this.setState({
      modalChildDelete: !this.state.modalChildDelete
    });
  }

  toggleMetadata = () => {
    this.setState({
      modalMetadata: !this.state.modalMetadata
    });
  }

  toggleMennyiseg = () => {
    this.setState({
      modalMennyiseg: !this.state.modalMennyiseg
    });
  }

  handleEditClick = (id) => {
    this.setState({modositas: true, currentId : id}, () => {
      this.toggleForm();
      this.getCikk(id);
    })
  }

  handleChildsClick = (id) => {
    if (!this.state.expanded.includes(id)) {
      Services.listReceptura(id, (err, res) => {
        if (!err) {
          let tempMap = this.state.recepturaJson;
          tempMap.set(id, res[0]);
          this.setState({ recepturaJson: tempMap });
        }
      });
      this.setState(() => ({
        expanded: [...this.state.expanded, id]
      }));
    } else {
      this.setState(() => ({
        expanded: this.state.expanded.filter(x => x !== id)
      }));
    }
  }

  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleDelete();
  }

  handleJellezmoDeleteClick = (key) => {
    this.setState(prevState => { return { formMetadata: prevState.formMetadata.filter(metadata => metadata.key != key )} });
  }

  handleViewClick = (id) => {
    this._currentViewId = id;
    
    Services.getCikk(id, (err, res) => {
      if (!err) {
        this.setState({
          cikk: res[0],
        });
      }
    });

    this.toggleView();
  }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  checkDate = (date) => {
    return date ? new Date(date) : null;
  }

  handleChangeCikkChild = (v, idx) => {
    let formChildsArray = [...this.state.formChilds];
    if (v) {
      let cikkFound = 0;
      formChildsArray.splice(idx, 1, v);
      for (let i = 0; i < formChildsArray.length; i++) {
        const cikk = formChildsArray[i];
        if (cikk.childid === v.id) {
          cikkFound++;
          if (cikkFound > 1)
            break;
        }
      }
      if (cikkFound < 2) {
        this.setState({ formChilds: formChildsArray });
      } else {
        this.props.globals.addError('A kiválasztott cikk már szerepel a receptúrában!');
      }
    }
  }

  newChild = () => {
    this.setState(prevState => ({ formChilds: [...prevState.formChilds, {}] }));
  }

  toggleChildTorles = (idx) => {
    this._currentDeleteChildId = idx;
    this.setState({
      modalChildTorles: !this.state.modalChildTorles
    });
  }

  deleteChild = (idx) => {
    let formChilds = this.state.formChilds;
    formChilds.splice(idx, 1);
    this.setState(prevState => ({ formChilds }), () => {
      this.toggleChildTorles();
    });
  }

  deleteCikktorzs = (id) => {
    this.setState({ cikkDeleteLoading: true }, () => {
      Services.deleteCikk(id, (err) => {
        this.setState({ cikkDeleteLoading: false });
        if (!err) {
          this.toggleDelete();
          this.getData();
          this.props.globals.addSuccess('Cikk törölve!');
        }
      });
    });
  }

  deleteMennyiseg = () => {
    Services.deleteMennyiseg(this.state.formMennyiseg, (err) => {
      if (!err) {
        this.setState({ formMennyiseg: '' });
        this.renderMennyisegOptions();
        this.props.globals.addSuccess('Mennyiség törölve!');
      }
    });
  }

  addMetadata = (e, mezoObj) => {
    if (this.state.formMetadata.some(metadata => metadata.nev == mezoObj.mezonev)) {
      this.props.globals.addError('Ez a jellemzőnév már felhasználásra került!');
      return;
    }
    let ujObj = {
      key: this.state.formMetadata.length + 1,
      nev: mezoObj.mezonev,
      ertek: mezoObj.tartalom
    };
    this.setState(prevState => { return { formMetadata: [...prevState.formMetadata, ujObj] }} ,() => this.toggleMetadata());
  }

  addMennyiseg = (e, mennyisegObj) => {
    Services.addMennyiseg(mennyisegObj.megnevezes, (err) => {
      if (!err) {
        this.toggleMennyiseg();
        this.renderMennyisegOptions();
        this.props.globals.addSuccess('Mennyiségi egység hozzáadva!');
      }
    });
  }

  iconFormatter = (cell, row) => {
    return (
      <div>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + '-view'} delay={0}>
          Megtekintés
        </UncontrolledTooltip>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + '-view'} onClick={() => this.handleViewClick(cell)} />

        {this.props.globals.hasRole(['CIKK_TORZS'], true) &&
          <>
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + '-edit'} delay={0}>
              Módosítás
            </UncontrolledTooltip>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + '-edit'} onClick={() => this.handleEditClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + '-delete'} delay={0}>
              Törlés
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + '-delete'} onClick={() => this.handleDeleteClick(cell)} />
          </>
        }
        {row.receptura &&
          <React.Fragment>
            <Button className="table-action-icon" id={'action-view-' + cell + '-childs'} onClick={() => this.handleChildsClick(cell)}>
              <i class="fa fa-cubes" />
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="top" target={'action-view-' + cell + '-childs'} delay={50}>
              {'Receptúra részei'}
            </UncontrolledTooltip>
          </React.Fragment>
        }
      </div>
    );
  }

  afaIconFormatter = (cell) => {
    return (
      <div>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + '-delete-afa'} delay={0}>
          Törlés
        </UncontrolledTooltip>
        <Button className="icon-trash table-action-icon" id={'action-view-' + cell + '-delete-afa'} onClick={() => this.handleDeleteClick(cell)} />
      </div>
    );
  }

  jellemzoIconFormatter = (cell, row) => {
    return (
      <div>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + row.key + '-delete-jellemzo'} delay={0}>
          Törlés
        </UncontrolledTooltip>
        <Button className="icon-trash table-action-icon" id={'action-view-' + row.key + '-delete-jellemzo'} onClick={() => this.handleJellezmoDeleteClick(row.key)} />
      </div>
    );
  }

  iconChildFormatter = (cell) => {
    return (
      <div>
        <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + '-view-child'} delay={0}>
          Megtekintés
        </UncontrolledTooltip>
        <Button className="icon-eye table-action-icon" id={'action-view-' + cell + '-view-child'} onClick={() => this.handleViewClick(cell)} />
      </div>
    );
  }

  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  renderFormTitle = () => {
    return this.state.modositas ? 'Cikk módosítása' : 'Új cikk rögzítése';
  }

  renderMetadatas = () => {
    const columns = [
      {
        dataField: 'nev',
        text: 'Jellemző neve',
      },
      {
        dataField: 'ertek',
        text: 'Jellemző értéke',
        headerClasses: 'w-auto',
        classes: 'w-auto',
        style: {
          whiteSpace: 'nowrap',
        },
        editable: true
      },
      {
        dataField: 'nev',
        text: 'Műveletek',
        formatter: this.jellemzoIconFormatter
      }
    ];
    return this.state.formMetadata && this.state.formMetadata.length > 0 && <>
      <BootstrapTable
        bootstrap4
        keyField="key"
        data={this.state.formMetadata}
        columns={columns}
        cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true })}
      />
    </>
  }

  renderChilds = () => {
    let childs = [];
    this.state.formChilds.forEach( (item, idx) => {
      childs.push(
        <span className="row mb-1 align-items-center" style={{ marginLeft: 10, marginRight: 10 }}>
          <div className="col-md-3">
              <Select
                styles={{
                  control: base => ({
                    ...base,
                    '&:focus': { borderColor: 'red' }, // border style on hover
                    border: '1px solid lightgray', // default border color
                    boxShadow: 'none', // no box-shadow
                    borderRadius: '0'
                  }),
                }}
                name={'cikkszam-' + idx}
                id={'cikkszam-' + idx}
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                onChange={v => this.handleChangeCikkChild(v, idx)}
                isClearable={false}
                ignoreAccents={false}
                loadOptions={_.debounce(this.loadOptionsCikkChildsCikkszam, 1000)}
                isLoading={false}
                getOptionLabel={option => option.childcikkszam}
                getOptionValue={option => option.childid}
                value={item || ''}
                cache={false}
                autoload={false}
              />
          </div>
          <div className="col-md-3">
              <Select
                styles={{
                  control: base => ({
                    ...base,
                    '&:focus': { borderColor: 'red' },
                    border: '1px solid lightgray',
                    boxShadow: 'none',
                    borderRadius: '0'
                  }),
                }}
                name={'megnevezes-' + idx}
                id={'megnevezes-' + idx}
                placeholder="Kezdj el gépelni..."
                noOptionsMessage={() => 'Nincs keresési eredmény'}
                searchPromptText="Kezdj el gépelni a kereséshez..."
                loadingMessage={() => 'Keresés...'}
                onChange={v => this.handleChangeCikkChild(v, idx)}
                isClearable={false}
                ignoreAccents={false}
                loadOptions={_.debounce(this.loadOptionsCikkChildsMegnevezes, 1000)}
                isLoading={false}
                getOptionLabel={option => option.childmegnevezes}
                getOptionValue={option => option.childid}
                value={item || ''}
                cache={false}
                autoload={false}
              />
          </div>
          <div className="col-md-3" style={{ paddingTop: 7 }}>
            <RFField
              id={"aktualisAfaNev" + idx}
              name={'aktualisAfaNev' + idx}
              className="mb-0"
              style={{ marginBottom: 0 }}
              value={item.id ? (item.childaktualisafanev + ' - (' + item.childaktualisafaertek + '%)') : ''}
              disabled
              required
            />
          </div>
          <div className="col-md-2">
            <SlaveAvInput
              id={"mennyiseg" + idx}
              className="mb-0"
              value={item.id ? item.childmennyiseg : ''}
              onChange={(e,v) => {
                const newChilds = this.state.formChilds;
                this.state.formChilds[idx].childmennyiseg = v.replace(',', '.');
                this.setState({formChilds: newChilds});
              }}
              szuroTipus={NumberFormatter.OSSZEG}
              emptyStringOnZero
            />
          </div>
          <div className="col-md-1">
            <Button color="danger" type="button" onClick={() => this.toggleChildTorles(idx)}>
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        </span>
      )
    });
    return childs;
  }

  renderForm = () => {
    const {
      formTipus,
      formReceptura,
      formCikkcsoport,
      formCikkszam,
      formMegnevezes,
      formMennyiseg,
      formAfa,
      formAfaKezdete,
      formWebshop,
      formRaktaronKivuli,
      formStatusz,
      cikkcsoportOptions,
      afaOptions,
      mennyisegOptions,
      hidden,
      modositas,
    } = this.state;

    return (
      <React.Fragment> 
        <div className="row mb-1 align-items-end">
          <div className="col-md-8">
            <legend>Cikk típusa</legend>
            <div className='ml-1'>
              <RFField
                name="formTipus"
                component="input"
                type="radio"
                onChange={this.handleInputChange}
                checked={formTipus === 'T'}
                label="Termék"
                value="T"
              />
              <RFField
                name="formTipus"
                component="input"
                type="radio"
                onChange={this.handleInputChange}
                checked={formTipus === 'SZ'}
                label="Szolgáltatás"
                value="SZ"
              />
            </div>
          </div>
          <div className="col-md-4">
            <SwichButton
              active={formReceptura}
              trueLabel="Összetett"
              trueToggle={() => this.setState({ formReceptura: true})}
              trueWidth={100}
              falseToggle={() => this.setState({ formReceptura: false, formChilds: []})}
              falseLabel="Egyszerű"
              falseWidth={100}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              type="select"
              name="formCikkcsoport"
              label="Cikkcsoport: *"
              value={formCikkcsoport}
              onChange={this.handleInputChange}
              defaultSelect={<option value="" disabled >Válassz cikkcsoportot...</option>}
              selectOptions={cikkcsoportOptions}
              required
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Cikkszám: *"
              name="formCikkszam"
              value={formCikkszam}
              onChange={this.handleInputChange}
              disabled={modositas}
              required
            />
          </div>
          <div className="col-md-4">
            <RFField
              label="Megnevezés: *"
              name="formMegnevezes"
              value={formMegnevezes}
              onChange={this.handleInputChange}
              required
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <RFField
              type="select"
              name="formMennyiseg"
              label="Mennyiségi egység: *"
              value={formMennyiseg}
              onChange={this.handleInputChange}
              required
              defaultSelect={<option value="" disabled >Válassz mennyiséget...</option>}
              selectOptions={mennyisegOptions}
            />
          </div>
          <div className="col-md-4">
            <Button type="button" id="MennyisegiEgysegModositas" className="btn-cursor-pointer" color="success" onClick={this.toggleMennyiseg} style={{ marginTop: '28px' }}>
              Új mennyiségi egység
            </Button>
            <UncontrolledTooltip trigger='hover focus-visible' placement="top" target="MennyisegiEgysegModositas"> Mennyiségi egység hozzáadása a már meglévőkhöz. </UncontrolledTooltip>

            { formMennyiseg !== '' && 
              <React.Fragment>
                <Button type="button" id="MennyisegiEgysegDelModositas" className="btn-cursor-pointer" color="danger" onClick={this.deleteMennyiseg} style={{ marginTop: '28px', marginLeft: '8px' }}>
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </Button>
                <UncontrolledTooltip trigger='hover focus-visible' placement="top" target="MennyisegiEgysegDelModositas"> Mennyiségi egység törlése. </UncontrolledTooltip>
              </React.Fragment>
            }
          </div>
          <div className="col-md-1">
          </div>
        </div>
          <div className="row" style={{paddingTop: 15}}>
            <div className="col-md-4">
              <RFField
                type="select" 
                name="formAfa" 
                label="Áfa: *"
                value={formAfa} 
                onChange={this.handleInputChange}  
                required
                defaultSelect={<option value="" disabled >Válassz áfát...</option>}
                selectOptions={afaOptions}
              />
            </div>
            <div className="col-md-4">
              <DatePicker 
                label="Kezdő dátum:"
                name="formAfaKezdete"
                value={this.checkDate(formAfaKezdete)}
                //defaultValue={new Date()}
                //onChange={this.handleInputChange}
                onChange={(e,v) => this.setState({formAfaKezdete : v})}
              />
            </div>
          </div>
        <div className="row">
          <div className='col mb-1'>
            {this.hasRoleSpec(['CIKK_WEBSHOP']) && 
              <div className="col-md-12" style={{ paddingLeft: 0 }}>
                <RFField
                  label="Webshop?"
                  type="checkbox"
                  name="formWebshop"
                  value={formWebshop}
                  onChange={this.handleInputChange}
                />
              </div>
            }
            <div hidden={hidden} className="col-md-12" style={{ paddingLeft: 0 }}>
              <RFField
                label="Raktáron kívüli"
                type="checkbox"
                name="formRaktaronKivuli"
                value={formRaktaronKivuli}
                onChange={this.handleInputChange}
              />
            </div>
            <RFField
                  type="select"
                  name="formStatusz"
                  label="Státusz: *"
                  onChange={this.handleInputChange}
                  value={formStatusz}
                  required
                  selectOptions={this.state.statuszOptions}
                />
          </div>
        </div>
        <h6>Cikk jellemzők:</h6>
        {this.renderMetadatas()}
        <Button type="button" className="btn-cursor-pointer" color="success" onClick={this.toggleMetadata} >Új mező</Button>
        {modositas && 
          <div className="row">
            <div className="col-md-12 amnezis-btn">
              <h6>Áfa kapcsolatok</h6>
            </div>
            <div className="col-md-12 ">
              {this.renderAfaTabla()}
            </div>
          </div>
        }
        {formReceptura &&
          <div style={{paddingTop: "20px", paddingBottom: "20px"}}> 
            <span> 
              <h5>Receptúra részei: </h5>
            </span>
            {this.state.formChilds && this.state.formChilds.length > 0 && (
              <div
                className="border rounded"
                style={{
                  marginLeft: 10, marginRight: 10, paddingBottom: 10
                }}
              >
                <div className="row mt-1" style={{ paddingLeft: 25, paddingRight: 60, marginBottom: 7 }}>
                  <div className="col-md-3" style={{ marginRight: 10 }}>
                    <Label style={{ marginBottom: 0 }}>Cikkszám:</Label>
                  </div>
                  <div className="col-md-3" style={{ marginRight: 10 }}>
                    <Label style={{ marginBottom: 0 }}>Megnevezés:</Label>
                  </div>
                  <div className="col-md-3" style={{ marginRight: 3 }}>
                    <Label style={{ marginBottom: 0 }}>Áfa:</Label>
                  </div>
                  <div className="col-md-2">
                    <Label style={{ marginBottom: 0 }}>Mennyiség:</Label>
                  </div>
                </div>
                <>
                  {this.renderChilds()}
                </>
              </div>
            )}
            <Button type="button" className="btn-cursor-pointer" style={{ marginTop: 10 }} color="success" onClick={this.newChild}>
                Hozzáadás
            </Button>
          </div>
        }
    </React.Fragment>
    );
  }

  renderView = (id) => {

    let mezoObj = [];
    let idx = 0;
    let statusz = '';
    if (this.state.cikk && this.state.cikk.metaadatok) {
      for (let key in this.state.cikk.metaadatok) {
        mezoObj.push(
          <div key={idx}>
            <b>{key}:{' '}</b>
            {this.state.cikk.metaadatok[key]}
          </div>);
        idx++;
      }
    }

    return (
      <div>
        <h6>Cikktörzs információ:</h6>
        <b>Megnevezés: </b>{this.state.cikk && this.state.cikk.megnevezes}<br />
        <b>Cikkcsoport neve: </b>{this.state.cikk && this.state.cikk.cikkcsoport && this.state.cikk.cikkcsoport.nev}<br />
        <b>Cikkszám: </b>{this.state.cikk && this.state.cikk.cikkszam}<br />
        <b>Típus: </b>{this.state.cikk && this.state.cikk.tipus === 'T' ? 'Termék' : 'Szolgáltatás'}<br />
        <b>Cikk típusa(Receptúra): </b>{this.state.cikk && this.state.cikk.haschild ? 'Összetett' : 'Egyszerű'}<br />
        <b>Mennyiségi egység: </b>{this.state.cikk && this.state.cikk.mennyiseg && this.state.cikk.mennyiseg.megnevezes}<br />
        <b>Áfa: </b>{this.state.cikk && this.state.cikk.aktualisAfaNev}{' '}({NumberFormatter.addSpacesToString(this.state.cikk && this.state.cikk.aktualisAfaErtek, NumberFormatter.OSSZEG)}{' '}%)<br />
        <b>Áfa érvényesség kezdete: </b>{this.state.cikk && this.state.cikk.aktualisAfaKezdete}<br />
        <br />
        {mezoObj.length ? <h6>Kiegészítő adatok: </h6> : <div />}
        {mezoObj}
        {mezoObj.length ? <br /> : <div />}

        {this.hasRoleSpec(['CIKK_WEBSHOP']) && <div><b>Webshop: </b>{this.state.cikk && this.state.cikk.webshop ? 'Igen' : 'Nem' }<br /></div>}
        <b>Raktáron kívüli: </b>{this.state.cikk && this.state.cikk.raktaronKivuli ? 'Igen' : 'Nem' }<br />
        <b>Státusz: </b>{this.state.cikk && this.state.statusz.find(x => x.name === this.state.cikk.statusz).caption }<br />
      </div>
    );
  }

  renderAfaTabla = () => {

    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [{
        text: '5', value: 5
      }, {
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }],
    };

    const columns = [
      {
        dataField: 'afaErtek',
        text: 'Cikkcsoport',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        formatter: (cell) => { return cell + '%'; }
      },
      {
        dataField: 'kezdete',
        text: 'Kezdete',
        style: {
          whiteSpace: 'pre-line'
        }
      },
      {
        dataField: 'vege',
        text: 'Vége',
        style: {
          whiteSpace: 'pre-line'
        }
      },
      // {
      //   dataField: 'id',
      //   text: 'Műveletek',
      //   formatter: this.afaIconFormatter
      // }
    ];

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.formAfaTable}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  renderTable = () => {
    const options = {
      sizePerPage: 50,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 },
        { text: '50', value: 50 },
      ],
    };

    const columns = [
      {
        dataField: 'cikkcsoport',
        text: 'Cikkcsoport',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'tipus',
        text: 'Típus',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'cikkszam',
        text: 'Cikkszám',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        }
      },
      {
        dataField: 'nev',
        text: 'Megnevezés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        }
      },
      {
        dataField: 'mennyisegiegyseg',
        text: 'Mennyiségi egység',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        }
      },
      {
        dataField: 'statusz',
        text: 'Státusz',
        filter: selectFilter({
          options: this.state.filterOptions, 
          placeholder: 'Összes',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: this.statusFormatter
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter
      }
    ];

    const childColumns = [
      {
        dataField: 'cikkcsoport',
        text: 'Cikkcsoport',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true
      },
      {
        dataField: 'tipus',
        text: 'Típus',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
      },
      {
        dataField: 'cikkszam',
        text: 'Cikkszám',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        }
      },
      {
        dataField: 'nev',
        text: 'Megnevezés',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        }
      },
      {
        dataField: 'mennyisegiegyseg',
        text: 'Mennyiségi egység',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: {
          whiteSpace: 'pre-line'
        }
      },
      {
        dataField: 'statusz',
        text: 'Státusz',
        filter: selectFilter({
          options: this.state.filterOptions, 
          placeholder: 'Összes',
        }),
        style: {
          whiteSpace: 'pre-line'
        },
        sort: true,
        formatter: this.statusFormatter
      },
      {
        dataField: 'mennyiseg',
        text: 'Mennyiség',
        filter: textFilter({
          delay: 400, // default is 500ms
          placeholder: 'Keresés...',
        }),
        style: NumberFormatter.styleTextAlignWhiteSpace,
        formatter: NumberFormatter.formatterSpaceOsszeg,
        sort: true,
      }
    ];

    const expandRow = {
      renderer: row => (row.receptura && this.state.recepturaJson.has(row.id) && this.state.recepturaJson.get(row.id).length > 0
        ? (
          <React.Fragment>
            <h5>Receptúra részei:</h5>
            <BootstrapTable
              bootstrap4
              keyField="id"
              data={this.state.recepturaJson.get(row.id)}
              columns={childColumns}
              filter={filterFactory()}
              pagination={paginationFactory(Lib.bootstraptableProps)}
              noDataIndication="Nincs megjelenítendő adat!"
            />
          </React.Fragment>
        )
        : null
      ),
      expanded: this.state.expanded,
      expandByColumnOnly: true
    };

    return (
      <div className="animated fadeIn">
        <BootstrapTable
          bootstrap4
          keyField="id"
          data={this.state.baseJson}
          columns={columns}
          filter={filterFactory()}
          pagination={paginationFactory(Lib.bootstraptableProps)}
          expandRow={expandRow}
          noDataIndication="Nincs megjelenítendő adat!"
        />
      </div>
    );
  }

  render = () => {
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-sm-12">
            {this.props.globals.hasRole(['CIKK_TORZS'], true) && 
              <Button className="pull-left table-new-button" color="primary" onClick={this.newCikkForm}>Új cikk</Button>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
                {{
                  QUERY: (<QueryEmptyState hasImage title="Az adatok megjelenítéséhez lekérdezés szükséges!" subtitle="Kérlek, használd a lekérdezés funkciót!" />),
                  LOAD: (<Loader />),
                  DATA: (<DataEmptyState
                    hasImage
                    subtitle="Vigyél fel új tételt!"
                  />),
                  NETW: (<NetworkEmptyState
                    hasImage
                    submitClick={() => this.getData()}
                  />),
                  TABL: (this.renderTable())
                }[this.state.tableStatus]}
          </div>
        </div>

        <Modal isOpen={this.state.modalForm} toggle={this.toggleForm} size="lg">
          <RFForm
            modal
            title={this.renderFormTitle()}
            onSubmit={this.handleSubmit}
            footer={
              <>
                <ProgressButton
                  className="btn-cursor-pointer"
                  color="primary"
                  loading={this.state.saveButtonLoading}
                >
                  {'Mentés'}
                </ProgressButton>
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.toggleForm}>Mégsem</Button>
              </>
            }
          >
            {{
              LOAD: (<Loader />),
              NETW: (<NetworkEmptyState
                hasImage
                submitClick={() => this.getCikk(this.state.currentId)}
              />),
              DATA: (this.renderForm())
            }[this.state.formStatus]}
          </RFForm>
        </Modal>

        <Modal isOpen={this.state.modalDelete} toggle={this.toggleDelete} className={this.props.className} backdrop="static">
          <ModalHeader >Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              className="btn-cursor-pointer"
              color="primary"
              loading={this.state.cikkDeleteLoading}
              onClick={() => this.deleteCikktorzs(this._currentDeleteId)}
            >
            OK
            </ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleDelete}>Mégsem</Button>
          </ModalFooter>
        </Modal>
      
        <Modal isOpen={this.state.modalView} toggle={this.toggleView} className={this.props.className} backdrop="static">
          <ModalHeader >Cikk információ</ModalHeader>
          <ModalBody>{this.state.modalView ? this.renderView(this._currentViewId) : <div />}</ModalBody>
          <ModalFooter> <Button type="button" color="primary" onClick={this.toggleView}>Vissza</Button></ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalMetadata} toggle={this.toggleMetadata} backdrop="static">
          <RFForm
            modal
            title="Új cikk jellemző felvétel"
            onSubmit={this.addMetadata}
            footer={
              <>
                <Button color="primary">Hozzáadás</Button>{' '}
                <Button type="button" color="secondary" onClick={this.toggleMetadata}>Mégsem</Button>
              </>
            }
          >
            <RFField
              label="Mező neve: *"
              name="mezonev"
              required
            />
            <RFField
              label="Mező tartalma: *"
              name="tartalom"
              required
            />
          </RFForm>
        </Modal>

        <Modal isOpen={this.state.modalMennyiseg} toggle={this.toggleMennyiseg} backdrop="static">
          <RFForm
            modal
            title="Új mennyiségi egység felvétel"
            onSubmit={this.addMennyiseg}
            footer={
              <>
                <Button className="btn-cursor-pointer" type='submit' color="primary">OK</Button>
                <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleMennyiseg}>Mégsem</Button>
              </>
            }
          >
            <RFField
              label="Mennyiségi egység neve: *"
              name="megnevezes"
              required
            />
          </RFForm>
        </Modal>

        <Modal isOpen={this.state.modalAfaDelete} toggle={this.toggleAfaDelete} className={this.props.className} backdrop="static">
          <ModalHeader >Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <Button className="btn-cursor-pointer" color="primary" onClick={() => this.deleteAfa(this._currentDeleteAfaId)}>OK</Button>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleAfaDelete}>Mégsem</Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.modalChildTorles} toggle={this.toggleChildTorles} className={this.props.className} backdrop="static">
          <ModalHeader >Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <Button className="btn-cursor-pointer" color="primary" onClick={() => this.deleteChild(this._currentDeleteChildId)}>OK</Button>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleChildTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
    </React.Fragment>
    );
  }
}

CikktorzsContent.propTypes = {
  globals: PropTypes.object,
  active: PropTypes.bool,
  className: PropTypes.string,
};

export default CikktorzsContent;